import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class ReportsDepreciationHeader extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    handleExport: PropTypes.func.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  handleExport = (e) => {
    e.preventDefault();
    this.props.handleExport();
  };

  handleExportPDF = (e) => {
    e.preventDefault();
    this.props.handleExportPDF();
  };

  render = () => <Common.Header title={this.props.t('reports.depreciation.title')}></Common.Header>;
}

export default translate()(ReportsDepreciationHeader);



// WEBPACK FOOTER //
// src/components/reports/depreciation/ReportsDepreciationHeader.js